import {collection, doc as docRef, getDoc, getDocs} from 'firebase/firestore';
import useSWR from 'swr';
import db from 'utils/fireStore';
import {IOppskrift, IOppskriftMedId} from '../types';

// Alle oppskrifter er synlige for alle, også uten innlogging.
const getOppskrifter = async (): Promise<IOppskriftMedId[]> => {
  const oppskrifterCollection = collection(db, 'oppskrifter');
  const oppskrifterSnapshot = await getDocs(oppskrifterCollection);
  return oppskrifterSnapshot.docs.map((doc) => ({...doc.data(), id: doc.id})) as IOppskriftMedId[];
};

export const getOppskrifterRefreshKey = 'oppskrifter';

export const useGetOppskrifter = () => {
  const {data: oppskrifter} = useSWR(getOppskrifterRefreshKey, getOppskrifter);
  return oppskrifter;
};

const getOppskrift = async (id: string): Promise<IOppskriftMedId | null> => {
  const oppskriftSnapshot = await getDoc(docRef(db, 'oppskrifter', id));
  if (!oppskriftSnapshot.exists()) return null;
  return {...oppskriftSnapshot.data(), id: oppskriftSnapshot.id} as IOppskriftMedId;
};

export const getOppskriftRefreshKey = (id: string) => ['oppskrift', id];

// Henter én oppskrift på dokument-id, uten å laste ned hele samlingen.
export const useGetOppskrift = (id?: string) => {
  const {data: oppskrift, isLoading} = useSWR(
      id ? getOppskriftRefreshKey(id) : null,
      () => getOppskrift(id as string),
  );
  return {oppskrift, isLoading};
};

const getFamilies = async (): Promise<any[]> => {
  const familyCollection = collection(db, 'family');
  const familySnapshot = await getDocs(familyCollection);
  let res = familySnapshot.docs.map((doc) => ({...doc.data(), id: doc.id})) as any[];
  res = await Promise.all(res.map(async (family) => {
    family.oppskrifter = await Promise.all(family.oppskrifter.map(async (oppskriftRef: any) => {
      const oppskrift = (await getDoc(oppskriftRef)).data() as IOppskrift;
      return {...oppskrift, id: oppskrift.id};
    }));
    return family;
  }));
  return res;
};

export const getFamiliesRefreshKey = 'families';

export const useGetFamilies = () => {
  const {data: families} = useSWR(getFamiliesRefreshKey, getFamilies);
  console.log(families);
  return families;
};
